import React from 'react'
import IconButtonMUI from '@mui/material/IconButton'
import { ButtonWithIconProps } from './ButtonWithIconTypes'
import { Colors } from 'constants/colors'

export default function IconButton({
  ...rest
}: ButtonWithIconProps): JSX.Element {
  return <IconButtonMUI sx={{ color: Colors.black }} {...rest} />
}
